
export const useApi = ({basePath = '/api', name = "ApiClient"}) => (resource, method = "POST", getJson=true) => async ( payload) => {
    const path = `${basePath}/${resource}`;
    console.log(`[${name}] fetch ${method} ${path}`, JSON.stringify(payload));
    
    const response = await fetch(path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: payload ? JSON.stringify(payload) : undefined
    });

    const {status: code} = response;
    const json = getJson ? await response.json() : await response.text();
    console.log(`[${name}] fetch ${method} ${path} response`, {code}, json ? JSON.stringify(json) : null, {response});

    if (!response.ok) {
        throw {code, ...json };
    }
    return json.data || json;
};

export default useApi;
